import { Check, ChevronsUpDown, Layers } from "lucide-react";
import { AD_PROVIDERS, AD_PROVIDER_LABELS } from "@app/shared";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useProviderFilter, type ProviderFilter } from "@/lib/provider";

const OPTIONS: { value: ProviderFilter; label: string }[] = [
  { value: "all", label: "Все платформы" },
  ...AD_PROVIDERS.map((p) => ({ value: p, label: AD_PROVIDER_LABELS[p] })),
];

/**
 * Which platform the dashboard shows, at the top of the rail like a workspace
 * switcher. The trigger is a rail row, so it is styled for the rail's own
 * ground; the menu floats over the page and uses the page theme.
 */
export function ProviderSwitch() {
  const { provider, setProvider } = useProviderFilter();
  const current = OPTIONS.find((o) => o.value === provider) ?? OPTIONS[0]!;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              icon={<Layers />}
              tooltip={`Платформа: ${current.label}`}
              trailing={<ChevronsUpDown className="size-3.5 opacity-60" />}
            >
              <span className="block truncate">{current.label}</span>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-56">
            <DropdownMenuLabel>Платформа</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {OPTIONS.map((o) => (
              <DropdownMenuItem key={o.value} onSelect={() => setProvider(o.value)}>
                <span className="flex-1">{o.label}</span>
                {o.value === provider && <Check className="size-4" />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
